"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchVehicleVrnAndDetailsFormDefinition = void 0;
const FormHandlerPluginBase_1 = require("../../../../PluginType/FormHandler/FormHandlerPluginBase");
const FormHandlerPluginDefinition_1 = require("../../../../PluginType/FormHandler/FormHandlerPluginDefinition");
class SearchVehicleVrnAndDetailsForm extends FormHandlerPluginBase_1.default {
    constructor() {
        super(...arguments);
        this.phase = 1;
    }
    /**
     * @inheritDoc
     */
    getValidationConfig() {
        return [
            ...SearchVehicleVrnAndDetailsForm.PHASE_ONE_VALIDATIONS,
            ...SearchVehicleVrnAndDetailsForm.PHASE_TWO_VALIDATIONS
        ];
    }
    /**
     * @param phase
     */
    setPhase(phase) {
        this.phase = phase;
    }
    /**
     * @inheritDoc
     */
    validate(values, action = "default") {
        return Promise.resolve().then(() => {
            this.getFormElement().classList.add('form-submitted');
            return super.validate(values, action);
        });
    }
    /**
     * @inheritDoc
     */
    submit(values, action = "default") {
        return Promise.resolve({
            vrm: values.get("registration_number").replace(/\s/g, ""),
        });
    }
}
exports.default = SearchVehicleVrnAndDetailsForm;
SearchVehicleVrnAndDetailsForm.PHASE_ONE_VALIDATIONS = [
    {
        inputId: '[name="registration_number"]',
        eventId: 'keyup',
        criteria: [
            {
                type: 'string_required',
                errorMessageId: 'required'
            }, {
                type: 'string_max_length',
                max: 7,
                errorMessageId: 'valid'
            }, {
                type: 'regex_pattern',
                pattern: '^[a-zA-Z0-9]{1,7}$',
                errorMessageId: 'valid'
            }
        ]
    },
    {
        inputId: '[name="state"]',
        eventId: 'change',
        criteria: [
            {
                type: 'selected',
                errorMessageId: 'required'
            }
        ]
    },
    {
        inputId: '[name="manufacturer"]',
        eventId: 'change',
        criteria: [
            {
                type: 'selected',
                errorMessageId: 'required'
            }
        ]
    },
    {
        inputId: '[name="model"]',
        eventId: 'change',
        criteria: [
            {
                type: 'selected',
                errorMessageId: 'required'
            }
        ]
    },
    {
        inputId: '[name="build_year"]',
        eventId: 'change',
        criteria: [
            {
                type: 'selected',
                errorMessageId: 'required'
            }
        ]
    },
];
SearchVehicleVrnAndDetailsForm.PHASE_TWO_VALIDATIONS = [
    {
        inputId: '[name="transmission"]',
        eventId: 'change',
        criteria: [
            {
                type: 'selected',
                errorMessageId: 'required'
            }
        ]
    },
    {
        inputId: '[name="fuel"]',
        eventId: 'change',
        criteria: [
            {
                type: 'selected',
                errorMessageId: 'required'
            }
        ]
    },
    {
        inputId: '[name="variant"]',
        eventId: 'change',
        criteria: [
            {
                type: 'selected',
                errorMessageId: 'required'
            }
        ]
    },
    {
        inputId: '[name="body_type"]',
        eventId: 'change',
        criteria: [
            {
                type: 'selected',
                errorMessageId: 'required'
            }
        ]
    }
];
exports.SearchVehicleVrnAndDetailsFormDefinition = new FormHandlerPluginDefinition_1.default({
    id: "search_vehicle_vrn_and_details_form",
    class: SearchVehicleVrnAndDetailsForm
});
